
import { Echangeur } from "../Echangeur";
import { traduit } from "./composant/b2bLangue";

// import Vue from "vue";
import { createApp } from "vue";
import html from "./signin.html";

const js = ({
	url: function (echangeur) {
	},
	onLoad: function (echangeur) {

		let THIS = this;

		const app = createApp({
			data: function () {
				return {
					failLogin: false,
					ecran: "login",

					passwordReset: false,
					afterPasswordReset: false,
					alertEmailSent: false,

					errorEmail: false,
					errorPassword: false,

					email: null,
					password: null,

					successLogin: false,

					resetErrorMessage: "",
				}
			},

			methods: {
				gotoReset() {
					this.resetErrorAndAlert();
					this.ecran = "reset";
				},
				gotoLogin() {
					this.resetErrorAndAlert();
					this.ecran = "login";
				},
				gotoResetSuccess() {
					this.resetErrorAndAlert();
					this.ecran = "resetsuccess";
				},
				gotoResetError(message) {
					this.resetErrorAndAlert();
					this.resetErrorMessage = message;
					this.ecran = "reseterror";
				},
				resetErrorAndAlert: function () {
					this.errorEmail = false;
					this.errorPassword = false;
					this.afterPasswordReset = false;
					this.alertEmailSent = null;
					this.failLogin = false;
					this.successLogin = false;
				},
				async submitLogin(event) {
					event.preventDefault();
					this.resetErrorAndAlert()
					if (!this.password) this.errorPassword = true
					if (!this.email) this.errorEmail = true
					//
					if (this.password && this.email) {
						var echangeur = new Echangeur();
						echangeur.addAction("sessionInit", {}, "", 'session');
						echangeur.loginInfo = { username: this.email, password: this.password }
						const x = await echangeur.runAsync({ nomodal: true }); //on verifie si on est authentifié
						this.email = null;
						this.password = null;

						if (x.erreur) {
							this.failLogin = true;
						} else {
							THIS.fin();
						}
					}
				},
				async submitReset(event) {
					event.preventDefault();
					this.resetErrorAndAlert()
					if (!this.email) this.errorEmail = true
					if (this.email) {
						const url = `motdepasseoublie/${encodeURIComponent(this.email)}`;
						const settings = {
							method: 'POST',
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						};
						try {
							const fetchResponse = await fetch(url, settings);
							if (fetchResponse.status == 200) {
								const form = await fetchResponse.json();
								if (form && !form.erreur) {
									this.gotoResetSuccess();
								} else if (form?.erreur) {
									this.gotoResetError(form.erreur);
								} else {
									this.gotoResetError("Unknown error");
								}
							} else {
								this.gotoResetError(`Unknown status : ${fetchResponse.status}`);
							}
							//
						} catch (ef) {
							this.gotoResetError("Communication error");
						}
					}
				},

				t(value) {
					return traduit(value, "account");
				},

			},
		});

		app.mount(THIS.c$('._vueChargement')[0]);

	},

});

export default {
	signin: { js: js, html: html }
};
